import RoutePaths from "./routes/Routes";
import { ErrorBoundary } from "@sentry/react";
import useAppInit from "./hooks/useAppInit";

function App() {
  useAppInit();

  return (
    <ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <RoutePaths />
    </ErrorBoundary>
  );
}

export default App;
